import { render, staticRenderFns } from "./ShippingAgents.vue?vue&type=template&id=085a4b98"
import script from "./ShippingAgents.vue?vue&type=script&lang=ts"
export * from "./ShippingAgents.vue?vue&type=script&lang=ts"
import style0 from "./ShippingAgents.vue?vue&type=style&index=0&id=085a4b98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports